import LinkedLinearIssues from './LinkedLinearIssues'
import LinkLinearIssue from './LinkLinearIssue'

export default function LinearIndex({ className, doNavigatableSetState }) {
  return (
    <div className={className}>
      <LinkedLinearIssues doNavigatableSetState={doNavigatableSetState} />
      <LinkLinearIssue />
    </div>
  )
}
